/**
 * Announcement bar: set --announcement-bar-height on document root.
 * Targets the first announcement bar section (class .shopify-section--announcement-bar).
 */
(function () {
  var section = document.querySelector('.shopify-section--announcement-bar');
  if (section) {
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      section.clientHeight.toFixed(2) + 'px'
    );
  }
})();
